import { Controller } from "@hotwired/stimulus"
import consumer from "../../channels/consumer"
import { visit } from "@hotwired/turbo"

export default class extends Controller {
  static values = {
    id: String,
    receiptUrl: String
  }
  static targets = ["qrCode", "success"]

  connect() {
    this.channel = consumer.subscriptions.create(
      {
        channel: "BitcoinInvoiceChannel",
        id: this.idValue
      },
      {
        received: this.handleReceived.bind(this)
      }
    )
  }

  disconnect() {
    this.channel.unsubscribe()
  }

  handleReceived(data) {
    console.log("BitcoinInvoiceChannel received", data)
    // replace the qr code with a success message
    // this.qrCodeTarget.classList.add("hidden")
    this.successTarget.classList.remove("hidden")
    setTimeout(() => {
      visit(this.receiptUrlValue)
    }, 2000)
  }
} 